import React from 'react';
import closeButton from '../assets/close.png';
import WarningBanner from './WarningBanner';
import { IPaymentsModal } from '../../../interfaces';
import {
  PM_CHILDREN,
  PM_CLOSE_CONTAINER,
  PM_CONTAINER,
  PM_CONTENT,
  PM_SUBTITLE,
  PM_TITLE,
} from './paymentsModalTestIds';

import styles from './PaymentModal.module.css';

const PaymentsModal: React.FunctionComponent<IPaymentsModal> = ({
  isOpen,
  onClose,
  hasError,
  title,
  subtitle,
  children,
}): JSX.Element | null =>
  isOpen ? (
    <div data-testid={PM_CONTAINER} className={styles.pmContainer}>
      <div data-testid={PM_CONTENT} className={styles.content}>
        <div
          data-testid={PM_CLOSE_CONTAINER}
          className={styles.close}
          onClick={onClose}
          onKeyPress={onClose}
          tabIndex={0}
          role="button"
          aria-label="Close this window"
        >
          <img src={closeButton} alt="close" />
        </div>
        <div data-testid={PM_TITLE} className={styles.pmTitle}>
          {title}
        </div>
        <div data-testid={PM_SUBTITLE} className={styles.pmSubtitle}>
          {subtitle}
        </div>
        {hasError && <WarningBanner />}
        <div data-testid={PM_CHILDREN} className={styles.content}>
          {children}
        </div>
      </div>
    </div>
  ) : null;

PaymentsModal.defaultProps = {
  title: '',
  subtitle: '',
  onClose: () => null,
  hasError: false,
};

export default PaymentsModal;
